import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Stars from "react-stars";
import { colors } from "core/stylesheet";
import { candidate } from "routes/paths";
import { Icon, BoxSpinner } from "components/generic/kit";
import { Container } from "components/generic/layout";
import * as model from "modules/insiders/model";
import { Overlay, Insider } from "components/common/candidate";

const Back = styled(Link)`
  text-decoration: none;
  font-weight: 600;
  color: ${colors.brand};
`;

export default ({ backLink = candidate.main, insider, isLoading }) => (
  <Overlay>
    <Container>
      {isLoading ? (
        <BoxSpinner />
      ) : (
        <div className="pv5">
          <div className="flex items-center mb3">
            {backLink !== "/" ? (
              <React.Fragment>
                <Icon className="mr1">keyboard_arrow_left</Icon>
                <Link to={backLink} className="link dib brand fr fw6">
                  Back to your search&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Icon className="mr1">keyboard_arrow_left</Icon>
                <Back to={candidate.main}>Back to all insiders</Back>
              </React.Fragment>
            )}
          </div>
          <Insider insider={insider} />
          {!!insider.rate &&
            !!insider.rate.criteria && (
              <div className="mt2 f6 pa3 br2 bg-white flex">
                {model
                  .getRatingDetails(insider.rate.criteria)
                  .map(({ criteria, stars }, i) => (
                    <div className="flex flex-row-ns flex-column items-center-ns">
                      <div className="w-40 f7 black mb1 pa3 mr3">
                        {criteria}
                      </div>
                      <div className="pa3-ns pa2">
                        <Stars
                          count={5}
                          size={16}
                          value={stars}
                          edit={false}
                          color="#ffd700"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            )}
          {!!insider.reviews && (
            <div className="mt2 f6 pa3 br2 bg-white">
              {model.getReviews(insider.reviews).map(({ text, date }, i) => (
                <div className={i !== 0 && "mt2 pt2 bt b--moon-gray"}>
                  <div className="flex items-center f7 silver mb1">
                    <Icon className="mr1">date_range</Icon>
                    {date}
                  </div>
                  <div>{text}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </Container>
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Insider/View.js